/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

import InputText from "../components/Input/InputText";
import {useDispatch} from "react-redux";
import {useEffect, useState} from "react";
import LandingIntro from "../features/user/LandingIntro";
import ErrorText from "../components/Typography/ErrorText";
import {fetchVerifyForgotPasswordUsersAction} from "../app/service/api/action/users/usersAction";
import {errorAlert, successAlert} from "../app/service/api/helper/handlingError";

const INITIAL_RESET_PASSWORD_OBJ = {
    password: "",
    retryPassword: "",
    email: "",
    token: ""
}

export const FormForgotPassword = () => {

    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [loadingButton, setLoadingButton] = useState(false)
    const [forgotPassword, serForgotPassword] = useState(INITIAL_RESET_PASSWORD_OBJ)
    const [errorMessage, setErrorMessage] = useState("")
    const [errorMessageRetry, setErrorMessageRetry] = useState("")

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);

        serForgotPassword({
            ...forgotPassword, email: params.get('email') ? decodeURIComponent(params.get('email')) : '',
            token: params.get('token') || ''
        })
    }, [forgotPassword]);

    const submitForm = (e) => {
        e.preventDefault()
        setLoading(true)
        dispatch(fetchVerifyForgotPasswordUsersAction(forgotPassword))
            .then(response => {
                console.log(response)
                if (response.responseData.code === 200 && response.result) {
                    setLoading(false)
                    successAlert("Password is changed successfully!!!")
                    setTimeout(() => {
                        window.location.href = "/login";
                    }, 2500);
                } else {
                    setLoading(false)
                    errorAlert(response.responseData.message)
                }
            })
            .catch((error) => {
                setLoading(false)
            })
    }

    const updateFormValue = ({updateType, value}) => {
        if (updateType === "password") {
            if (value.length < 8) {
                return setErrorMessage("Password must be at least 8 characters")
            } else {
                setErrorMessage("")
            }
        }

        if (updateType === "retryPassword") {
            if (value.length < 8) {
                setLoadingButton(false)
                return setErrorMessageRetry("Password must be at least 8 characters")
            } else if (value !== forgotPassword.password) {
                setLoadingButton(false)
                return setErrorMessageRetry("Password don't match!")
            } else {
                setErrorMessageRetry("")
                setLoadingButton(true)
            }
        }
        serForgotPassword({...forgotPassword, [updateType]: value})
    }

    return (
        <div className="min-h-screen bg-base-200 flex items-center">
            <div className="card mx-auto w-full max-w-5xl  shadow-xl">
                <div className="grid  md:grid-cols-2 grid-cols-1  bg-base-100 rounded-xl">
                    <div className=''>
                        <LandingIntro/>
                    </div>
                    <div className='py-24 px-10'>
                        <h2 className='text-2xl font-semibold mb-2 text-center'>Form Reset Password</h2>
                        <div className="mb-4">

                            <form method={'POST'} onSubmit={(e) => submitForm(e)}>
                                <InputText type="password" defaultValue={forgotPassword.password}
                                           updateType="password"
                                           containerStyle="mt-4" labelTitle="New Password"
                                           updateFormValue={updateFormValue}/>
                                <ErrorText styleClass="mt-8">{errorMessage}</ErrorText>
                                <InputText type="password" defaultValue={forgotPassword.retryPassword}
                                           updateType="retryPassword"
                                           containerStyle="mt-4" labelTitle="Retry Password"
                                           updateFormValue={updateFormValue}/>
                                <ErrorText styleClass="mt-8">{errorMessageRetry}</ErrorText>
                                {loadingButton &&
                                    (
                                        <button type={'submit'}
                                                className={"btn mt-2 w-full btn-primary" + (loading ? " loading" : "")}>
                                            Reset Password
                                        </button>
                                    )}
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
